// @ts-nocheck
import { Checkbox } from "antd";
import EllipsisToolTip from "../../../../../../base/basicComponents/ellipsisToolTip";
import Buttons from "../../../../../../base/basicComponents/button";
import NormalSelect from "../../../../../../base/basicComponents/select";
import { FileStatusDiv } from "../../../../../../base/basicComponents/status";
import ReturnReasonHypelink from "../../../../../../base/basicComponents/returnReasonHypelink";
import UploadFile from "../../../../../../base/basicComponents/uploadFile";
import EditIcon from "../../../../../../base/basicComponents/EditIcon";
import { dataStatus, fileTags } from "../../../../../publicDictionaryValues";
import BaseTbody from "../../../../../commonComponents/fileTbodys/baseFileTbody";
import { createRef } from "react";
import "../index.scss";
import ViewNoteHyperLinkModal from "../../../../../../base/basicComponents/viewNoteHyperLinkModal";
import TextEllipsis from "../../../../../../base/basicComponents/viewNoteHyperLinkModal/TextEllipsis";
import { PreviewFileLink } from "app/pages/previewFile";

const ReturnResonRef = createRef();
class ApproveProcedureFileTbody extends BaseTbody {
  constructor(props: any) {
    super(props);
    this.state = {
      inputRef: "",
    };
    // @ts-ignore
    this.isHideReplaceBtn = false;
    // @ts-ignore
    this.isHideDeleteBtn = false;
    // @ts-ignore
    this.isHideApproveBtn = false;
    // @ts-ignore
    this.isHideReturnBtn = false;
  }

  /**
   * function about show checkbox if column type is checkbox
   * @param {*} column
   * @param {*} row
   * @returns
   */
  returnCheckBox = (column: any, row: any) => {
    const lineId = row.data.find((item: any) => item.name === "lineId").value;
    return (
      <td key={lineId} className="checkboxtd">
        <Checkbox
          checked={
            column.check(row.data.find((x: any) => x.name === "lineId").value) ? true : false
          }
          onChange={(e) =>
            column.onCheck(row.data.find((x: any) => x.name === "lineId").value, e.target)
          }
        />
      </td>
    );
  };

  /**
   * function about show link if column type is link
   * @param {*} rowColumn
   * @param {*} column
   * @param {*} rowIndex
   * @param {*} row
   * @returns
   */
  // @ts-ignore
  returnLink = (rowColumn: any, column: any, rowIndex: any, row: any) => {
    const fileTag = row.data.find((item: any) => item.name === "fileName").tagValue;

    return (
      <div className="linkContainer">
        {/* @ts-ignore */}
        <PreviewFileLink
          disabled={rowColumn.tagValue === fileTags.deleted}
          fileName={rowColumn.value}
          fileId={rowColumn.fileId}
          className="linkName"
        >
          <EllipsisToolTip children={rowColumn.value} title={rowColumn.value} placement="top" />
        </PreviewFileLink>

        {rowColumn.name === "attachment" && rowColumn.value !== null && column.showEdit && (
          <EditIcon
            className="editAttachment"
            onClick={(e: any) => this.props.handleReturnClick(e)}
            rowindex={rowIndex}
            altText="Edit Attachment"
          />
        )}
      </div>
    );
  };

  /**
   * function about show link if column type is link
   * @param {*} rowColumn
   * @param {*} column
   * @returns
   */
  returnFileName = (rowColumn: any, column: any, row: any) => {
    return (
      <div className="fileNameContainer">
        <EllipsisToolTip
          children={
            <PreviewFileLink
              fileId={row.data.find((i: any) => i.name === "fileId").value}
              fileName={rowColumn.value}
            >
              {rowColumn.value}
            </PreviewFileLink>
          }
          title={rowColumn.value}
          placement="top"
        />
        {column.tagValue !== null && <FileStatusDiv status={rowColumn.tagValue} />}
      </div>
    );
  };

  /**
   * function about show input if column type is input
   * @param {*} row
   * @param {*} rowColumn
   * @param {*} column
   * @param {*} rowIndex
   * @param {*} isShowReturnReason
   * @param {*} procedureNoteMaxLength
   * @returns
   */
  // @ts-ignore
  returnInput = (
    row: any,
    rowColumn: any,
    column: any,
    rowIndex: any,
    isShowReturnReason: any,
    procedureNoteMaxLength: any
  ) => {
    const fileTage =
      row.data.find((item: any) => item.name === "fileName") !== undefined &&
      row.data.find((item: any) => item.name === "fileName").tagValue;

    return (
      <>
        {rowColumn.name === "returnReason" && isShowReturnReason && (
          <>
            <ReturnReasonHypelink
              inputRef={ReturnResonRef}
              value={rowColumn.value}
              rowindex={rowIndex}
              isShowEditBtn={rowColumn.value !== null && column.showEdit}
              handleReturnEditClick={(e: any) => {
                this.props.handleReturnClick(e);
              }}
              isShowReasonLogIcon={rowColumn.isShowReasonLog}
              reasonLog={rowColumn.reasonLog}
              isTable={true}
            />
          </>
        )}
        {rowColumn.name === "note" && <ViewNoteHyperLinkModal value={rowColumn.value} />}
        {rowColumn.name === "rejectReason" && (
          <div className="rejectReasonContainer">
            {rowColumn.value && (
              <TextEllipsis
                onClick={(e: any) => {
                  this.props.handleReturnClick(e, true);
                }}
                style={{ minWidth: "0" }}
                rowindex={rowIndex}
              >
                {rowColumn.plainText}
              </TextEllipsis>
            )}
            {rowColumn.value && column.showEdit && (
              <EditIcon
                className="editAttachment"
                onClick={(e: any) => this.props.handleReturnClick(e)}
                rowindex={rowIndex}
                altText="Edit Reject Reason"
              />
            )}
          </div>
        )}
      </>
    );
  };

  /**
   * function about show select if column tye is select
   * @param {*} currentRole
   * @param {*} rowColumn
   * @param {*} column
   * @param {*} row
   * @param {*} rowIndex
   * @param {*} optionList
   * @returns
   */
  // @ts-ignore
  returnSelect = (
    currentRole: any,
    rowColumn: any,
    column: any,
    row: any,
    rowIndex: any,
    optionList: any
  ) => (
    <>
      <NormalSelect
        optionList={rowColumn.optionList}
        disabled={rowColumn.isDisabled || column.isDisabled || row.isReturned}
        value={rowColumn.value}
        handleChange={(e: any) => column.onChange(e, rowIndex)}
      />
    </>
  );

  /**
   * function about show button if column type is button
   * @param {*} row
   * @param {*} column
   * @param {*} rowIndex
   * @param {*} status
   * @returns
   */
  // @ts-ignore
  returnButton = (row: any, column: any, rowIndex: any, status: any) => {
    const fileNameData = row.data.find((item: any) => item.name === "fileName");
    const tagValue = fileNameData && fileNameData.tagValue;
    const { isDisableAllActionButtons = false } = column;
    if (column.hideActionButton !== undefined && column.hideActionButton(row)) {
      return;
    }
    return (
      <div className="buttonTd-content">
        {/* @ts-ignore */}
        {!this.isHideReplaceBtn && !(tagValue === fileTags.deleted && status.value === null) && (
          <>
            <Buttons
              color={column.approveColor}
              size="small"
              onClick={(e: any) => column.onApproveClick(e.target.attributes.rowindex.value)}
              disabled={row.isApproveDisabled || isDisableAllActionButtons}
              rowindex={rowIndex}
              testid={`approve-procedure-file-approve-btn-${rowIndex}`}
            >
              {column.approveText}
            </Buttons>
            <UploadFile
              fileInputRef={row.replaceRef}
              isMultiple={false}
              handleFileSelect={this.props.handleFileSelect}
              rowindex={rowIndex}
              isSupportingFile={false}
            />
          </>
        )}
        {/* @ts-ignore */}
        {!this.isHideDeleteBtn && !(tagValue === fileTags.deleted && status.value === null) && (
          <Buttons
            color={column.returnColor}
            size="small"
            onClick={() => column.onReturnClick(rowIndex)}
            disabled={
              row.isReturnDisabled || tagValue === fileTags.deleted || isDisableAllActionButtons
            }
            rowindex={rowIndex}
            testid={`approve-procedure-file-return-btn-${rowIndex}`}
          >
            {column.returnText}
          </Buttons>
        )}
      </div>
    );
  };

  returnModal = (rowColumn: any, column: any, row: any, rowIndex: any) => {
    return (
      <div>
        {/* @ts-ignore */}
        <p
          className="modalLink"
          onClick={(e) => this.props.handleReturnClick(e)}
          rowindex={rowIndex}
        >
          {rowColumn.value !== "" && rowColumn.value !== null && column.showText}
        </p>
      </div>
    );
  };

  /**
   * function about control the replace and delete buttons show in revise page
   * @param {*} row
   */
  judgeIsShowReplaceAndDeleteBtn = (row: any) => {
    const fileNameData = row.data.find((item: any) => item.name === "fileName");
    const tagValue = fileNameData && fileNameData.tagValue;
    const isApprovedBefore =
      row.data.find((item: any) => item.name === "previousStatus").value === dataStatus.approval;
    // @ts-ignore
    this.isHideReplaceBtn =
      (tagValue === fileTags.deleted &&
        row.data.find((x: any) => x.name === "status").value === dataStatus.return) ||
      isApprovedBefore;
    // @ts-ignore
    this.isHideDeleteBtn =
      (tagValue === fileTags.deleted &&
        row.data.find((x: any) => x.name === "status").value === dataStatus.return) ||
      isApprovedBefore;
  };

  /**
   * control display text base on column type
   * @param {*} column
   * @returns
   */
  judgeIsShowText = (column: any) => {
    return (
      column.type !== "link" &&
      column.type !== "input" &&
      column.type !== "select" &&
      column.type !== "tag" &&
      column.type !== "button" &&
      column.type !== "fileName" &&
      column.type !== "modal"
    );
  };

  returnTrErrorClass = (row: any) => (row.isError ? "red" : "normal");

  columnShowStyle = (column: any) => (column.isShow ? "table-cell" : "none");

  render() {
    const {
      data,
      columns,
      procedureNoteMaxLength,
      fileSectionDisabled,
      optionList,
      isShowReturnReason,
      currentRole,
    } = this.props;

    const typeToClassName = {
      link: "linkTd",
      input: "inputTd",
      default: "textTd",
      tag: "tagTd",
      select: "selectTd",
      button: "buttonTd",
      fileName: "fileNameTd",
      modal: "modalTd",
    };

    return (
      <>
        <tbody>
          {data.map((row: any, rowIndex: any) => {
            const fileNameData = row.data.find((item: any) => item.name === "fileName");
            const status = row.data.find((item: any) => item.name === "status");
            fileNameData &&
              (status || fileNameData.tagValue) &&
              this.judgeIsShowReplaceAndDeleteBtn(row);
            return (
              <tr
                key={row.data.find((item: any) => item.name === "lineId").value}
                className={`table-tr ${this.returnTrErrorClass(row)}`}
                id={`table-tr-${rowIndex}`}
              >
                {columns.map((column: any, columnIndex: any) => {
                  if (!column.isShow) {
                    return;
                  }
                  const rowColumn = row.data.find((x: any) => x.name === column.dataName);

                  const tagValue = row.data.find((x: any) => x.name === "fileName").tagValue;
                  if (column.type === "checkbox") {
                    return this.returnCheckBox(column, row);
                  } else {
                    return (
                      // @ts-ignore
                      <td
                        key={column.dataName}
                        style={{
                          display: this.columnShowStyle(column),
                        }}
                        className={typeToClassName[column.type] || typeToClassName.default}
                      >
                        {column.type === "link" &&
                          this.returnLink(rowColumn, column, rowIndex, row)}
                        {column.type === "fileName" && this.returnFileName(rowColumn, column, row)}
                        {/* @ts-ignore */}
                        {column.type === "input" &&
                          this.returnInput(
                            row,
                            rowColumn,
                            column,
                            rowIndex,
                            isShowReturnReason,
                            procedureNoteMaxLength,
                            fileSectionDisabled
                          )}
                        {column.type === "select" &&
                          this.returnSelect(
                            currentRole,
                            rowColumn,
                            column,
                            row,
                            rowIndex,
                            optionList
                          )}
                        {column.type === "button" &&
                          this.returnButton(row, column, rowIndex, status)}
                        {column.type === "tag" && this.returnTag(column, rowColumn, tagValue)}
                        {column.type === "modal" &&
                          this.returnModal(rowColumn, column, row, rowIndex)}
                        {this.judgeIsShowText(column) && rowColumn.value}
                      </td>
                    );
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </>
    );
  }
}

export default ApproveProcedureFileTbody;
